import AxiosConfig from '@/config/axios-config'

export const UsuarioAPI = {

  obterUsuario () {
    return AxiosConfig.secureJalekoAPI().get('/user')
      .then(response => response.data)
      .then(data => {
        if (data.user && data.user.empresa) {
          const empresa = parseInt(process.env.VUE_APP_EMPRESA_REF)
          if (Array.isArray(data.user.empresa) && !data.user.empresa.some(item => item.id === empresa)) {
            throw new Error('Email e/ou senha inválida.')
          }
        }

        return data
      })
  },

  login (username, password) {
    return AxiosConfig.jalekoAPI().post('/oauth/token',
      {
        grant_type: process.env.VUE_APP_GRANT_TYPE,
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        username: username,
        password: password,
        scope: process.env.VUE_APP_SCOPE
      }
    ).then(response => response.data)
  },

  validarAcesso (token) {
    return AxiosConfig.jalekoAPI().get('/user/validate-access/' + token + '?empresaId=' + process.env.VUE_APP_EMPRESA_REF)
      .then(response => {
        return response.data
      })
  },

  recuperarSenha (email) {
    return AxiosConfig.jalekoAPI().post('reset_password_without_token', { email: email, reset_url: window.location.origin }).then(response => response.data)
  },

  redefinirSenha (email, senha, token, empresaId) {
    return AxiosConfig.jalekoAPI().post('reset_password_with_token', { email: email, password: senha, token: token, empresa_id: empresaId }).then(response => response.data)
  },

  obterPlanoUsuario () {
    return AxiosConfig.secureJalekoAPI().get('planoUsuario').then(response => response.data)
  },

  alternarDarkMode () {
    return AxiosConfig.secureJalekoAPI().post('modonoturno').then(response => response.data)
  },

  aceitaTermosUso () {
    return AxiosConfig.secureJalekoAPI().get('/user/aceiteTermos').then(response => response.data)
  },

  pegaTutorias () {
    return AxiosConfig.secureJalekoAPI().get('/user/tutorias').then(response => response.data)
  }

}

export default UsuarioAPI
